import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import authService from '../../../../services/auth.service';
import Swal from 'sweetalert2';
import './Auth.css';

const ResetPasswordConfirm = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    // Validation Rules (Matches Register.jsx)
    const validatePassword = (val) => {
        if (val.length < 6) return 'Mínimo 6 caracteres.';
        if (!/[A-Z]/.test(val)) return 'Debe tener una mayúscula.';
        if (!/[a-z]/.test(val)) return 'Debe tener una minúscula.';
        if (!/[0-9]/.test(val)) return 'Debe tener un número.';
        return null;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!uid || !token) {
            Swal.fire('Error', 'Enlace inválido o incompleto.', 'error');
            return;
        }

        if (password !== confirmPassword) {
            Swal.fire('Error', 'Las contraseñas no coinciden.', 'error');
            return;
        }

        const passError = validatePassword(password);
        if (passError) {
            Swal.fire('Contraseña Insegura', passError, 'warning');
            return;
        }

        setLoading(true);
        try {
            await authService.confirmPasswordReset({
                uid,
                token,
                password
            });

            Swal.fire({
                title: '¡Éxito!',
                text: 'Tu contraseña ha sido restablecida correctamente.',
                icon: 'success',
                confirmButtonColor: '#FF6B35'
            }).then(() => {
                navigate('/login');
            });
        } catch (error) {
            console.error(error);
            Swal.fire('Error', error.response?.data?.detail || 'No se pudo restablecer la contraseña.', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (!uid || !token) {
        return (
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                        <h2>Enlace Inválido</h2>
                        <p style={{ color: 'red' }}>Faltan parámetros de seguridad en el enlace.</p>
                    </div>
                    <div className="login-footer">
                        <p onClick={() => navigate('/login')}>Volver al Login</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>Restablecer Contraseña</h2>
                    <p>Ingresa tu nueva contraseña</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group-custom">
                        <label className="form-label-custom">Nueva Contraseña</label>
                        <input
                            type="password"
                            className="form-control-custom"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Mínimo 6 caracteres"
                        />
                        {password && validatePassword(password) && (
                            <span style={{ color: 'red', fontSize: '12px' }}>{validatePassword(password)}</span>
                        )}
                    </div>

                    <div className="form-group-custom">
                        <label className="form-label-custom">Confirmar Contraseña</label>
                        <input
                            type="password"
                            className="form-control-custom"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn-custom btn-primary full-width" disabled={loading} style={{ marginTop: '20px' }}>
                        {loading ? 'Restableciendo...' : 'Confirmar Nueva Contraseña'}
                    </button>
                </form>
            </div>
            <div className="login-info">
                <h2>Seguridad ante todo</h2>
                <p>Para proteger tu cuenta, asegúrate de:</p>
                <ul>
                    <li>Usar mayúsculas, minúsculas y números.</li>
                    <li>No usar datos personales obvios.</li>
                    <li>Nunca compartir tu contraseña.</li>
                </ul>
            </div>
        </div>
    );
};

export default ResetPasswordConfirm;
